import type { HITLRequestConfirmationMessage } from '@terra/shared-dto-chat-types';
import { appendBackgroundSubagentHitlPart } from '../store/backgroundExecutionStore';
import { useChatInstancesStore } from '../store/chatInstancesStore';

export function restorePendingBackgroundSubagentHitl({
  chatId,
  toolCallId,
  confirmation,
}: {
  chatId: string;
  toolCallId: string;
  confirmation: HITLRequestConfirmationMessage;
}): void {
  const { chats, configs } = useChatInstancesStore.getState();
  const chat = chats.get(chatId);
  const setMessages = configs.get(chatId)?.setMessages;

  if (!chat || !setMessages) {
    return;
  }

  const next = appendBackgroundSubagentHitlPart({
    messages: chat.messages,
    toolCallId,
    confirmation,
  });

  if (next !== chat.messages) {
    setMessages(next);
  }
}
